// Header Next's client puts on every server-action POST; its value is the action ID
const SERVER_ACTION_ID_HEADER = "next-action";

// Header Next's server sets when the action itself called redirect(); such a reply legitimately carries no flight payload
const SERVER_ACTION_REDIRECT_HEADER = "x-action-redirect";

// Content type of a real server-action reply (a React flight payload)
const SERVER_ACTION_REPLY_CONTENT_TYPE = "text/x-component";

// Statuses the not-found page comes back with for an unknown action: 200 as observed on Next 15.2.6, 404 as Next's action handler nominally sets. Anything else (413 over the body limit, 429, a 5xx platform error page) is also a non-flight reply but is not skew.
const STALE_ACTION_REPLY_STATUSES = new Set([200, 404]);

// Returns the action ID when the reply shows the deployment didn't recognise it, otherwise null. Such a deployment answers with the not-found HTML page and status 200 (verified on Next 15.2.6), so Next's client throws nothing and the action call silently resolves to undefined — a server-action POST whose reply is not a flight payload is the only observable signature.
export const getStaleServerActionId = (
  requestHeaders: Headers,
  response: Response
): string | null => {
  const serverActionId = requestHeaders.get(SERVER_ACTION_ID_HEADER);
  if (serverActionId === null) {
    return null;
  }

  // An expired session makes the auth middleware redirect the POST to the sign-in page, which is also HTML — that is a signed-out tab, not a stale one
  if (response.redirected) {
    return null;
  }

  const isRedirectFromAction = response.headers.has(
    SERVER_ACTION_REDIRECT_HEADER
  );
  if (isRedirectFromAction) {
    return null;
  }

  const replyContentType = response.headers.get("content-type");
  const isServerActionReply =
    replyContentType !== null &&
    replyContentType.startsWith(SERVER_ACTION_REPLY_CONTENT_TYPE);

  const isStaleActionReply =
    STALE_ACTION_REPLY_STATUSES.has(response.status) && !isServerActionReply;

  return isStaleActionReply ? serverActionId : null;
};
